import { render, staticRenderFns } from "./HomeSecuritySystem.vue?vue&type=template&id=64b2c44d&"
import script from "./HomeSecuritySystem.vue?vue&type=script&lang=js&"
export * from "./HomeSecuritySystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports